function qs(root, sel) {
  return root.querySelector(sel);
}

function qsa(root, sel) {
  return Array.from(root.querySelectorAll(sel));
}

class HomeStories {
  constructor(section) {
    this.section = section;
    this.dialog = qs(section, '[data-home-stories-dialog]');
    this.viewer = qs(section, '[data-home-stories-viewer]');
    this.progress = qs(section, '[data-home-stories-progress]');
    this.dataEl = qs(section, '[data-home-stories-data]');
    this.btnClose = qs(section, '[data-home-stories-close]');
    this.btnPrev = qs(section, '[data-home-stories-prev]');
    this.btnNext = qs(section, '[data-home-stories-next]');
    this.openButtons = qsa(section, '[data-home-stories-open]');

    // TOPBAR
    this.topbar = qs(section, '[data-home-stories-topbar]');
    this.topbarIcon = qs(section, '[data-home-stories-topbar-icon]');
    this.topbarTitle = qs(section, '[data-home-stories-topbar-title]');

    this.state = {
      groupIndex: 0,
      slideIndex: 0,
      timer: null,
      durationMs: 3500,
      groups: [],
      isMuted: false
    };

    // Video refs
    this.activeVideo = null;
    this.onVideoEnded = null;

    this.load();
    this.bind();
  }

  load() {
    if (!this.dataEl) return;
    const parsed = JSON.parse(this.dataEl.textContent || '{}');
    this.state.durationMs = parsed.durationMs || 3500;
    this.state.groups = parsed.groups || [];
  }

  bind() {
    this.openButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const handle = btn.dataset.groupHandle;
        const index = this.state.groups.findIndex(g => g.handle === handle);
        if (index !== -1) this.open(index, 0);
      });
    });

    this.btnClose?.addEventListener('click', () => this.close());
    this.btnPrev?.addEventListener('click', () => this.prev());
    this.btnNext?.addEventListener('click', () => this.next());

    this.dialog?.addEventListener('click', e => {
      if (e.target === this.dialog) this.close();
    });

    this.viewer?.addEventListener('click', e => {
      if (e.target.closest('[data-home-stories-sound]')) return;

      const video = this.viewer?.querySelector('video');
      if (video && video.paused) {
        video.play().catch(() => {});
        return;
      }

      const rect = this.viewer.getBoundingClientRect();
      const x = e.clientX - rect.left;
      if (x < rect.width * 0.35) this.prev();
      else this.next();
    });
  }

  getCurrent() {
    const g = this.state.groups[this.state.groupIndex];
    const item = g?.items?.[this.state.slideIndex];
    return { g, item };
  }

  open(groupIndex, slideIndex) {
    this.state.groupIndex = groupIndex;
    this.state.slideIndex = slideIndex;
    this.render();
    this.dialog.showModal();
    this.play();
  }

  close() {
    this.stop();
    this.dialog.close();
  }

  prev() {
    const { g } = this.getCurrent();
    if (!g) return;

    if (this.state.slideIndex > 0) {
      this.state.slideIndex--;
    } else if (this.state.groupIndex > 0) {
      this.state.groupIndex--;
      const ng = this.state.groups[this.state.groupIndex];
      this.state.slideIndex = (ng?.items?.length || 1) - 1;
    }
    this.render();
    this.play();
  }

  next() {
    const { g } = this.getCurrent();
    if (!g) return;

    if (this.state.slideIndex < g.items.length - 1) {
      this.state.slideIndex++;
    } else if (this.state.groupIndex < this.state.groups.length - 1) {
      this.state.groupIndex++;
      this.state.slideIndex = 0;
    } else {
      this.close();
      return;
    }
    this.render();
    this.play();
  }

  updateTopbar() {
    if (!this.topbar || !this.topbarIcon || !this.topbarTitle) return;

    const g = this.state.groups[this.state.groupIndex];
    if (!g) return;

    this.topbarTitle.textContent = (g.title || '').trim() || 'Historia';

    if (g.icon && String(g.icon).trim() !== '') {
      this.topbarIcon.src = g.icon;
      this.topbarIcon.style.display = '';
    } else {
      this.topbarIcon.removeAttribute('src');
      this.topbarIcon.style.display = 'none';
    }
  }

  render() {
    const { g, item } = this.getCurrent();
    if (!item) return;

    this.updateTopbar();

    const isVideo = item.type === 'video' && item.video;

    this.viewer.innerHTML = `
      <div style="position:relative;width:100%;height:100%;">
        ${
          isVideo
            ? `<video class="home-stories__media"
                 src="${item.video}"
                 ${item.poster ? `poster="${item.poster}"` : ``}
                 autoplay
                 playsinline
                 preload="metadata"
                 ${this.state.isMuted ? 'muted' : ''}
               ></video>
               <button
                 type="button"
                 class="home-stories__sound-toggle"
                 data-home-stories-sound
                 aria-label="${this.state.isMuted ? 'Activar sonido' : 'Silenciar'}"
               >
                 ${this.state.isMuted ? '🔇' : '🔊'}
               </button>`
            : `<img class="home-stories__media" src="${item.image}" alt="">`
        }
        ${item.text ? `<div class="home-stories__text">${item.text}</div>` : ``}
      </div>
    `;

    const soundBtn = this.viewer.querySelector('[data-home-stories-sound]');
    if (soundBtn) {
      soundBtn.addEventListener('click', (e) => {
        e.stopPropagation();

        const video = this.viewer.querySelector('video');
        if (!video) return;

        this.state.isMuted = !video.muted;
        video.muted = this.state.isMuted;

        soundBtn.textContent = this.state.isMuted ? '🔇' : '🔊';
        soundBtn.setAttribute(
          'aria-label',
          this.state.isMuted ? 'Activar sonido' : 'Silenciar'
        );

        if (video.paused) {
          video.play().catch(() => {});
        }
      });
    }

    this.progress.innerHTML = '';
    g.items.forEach((_, i) => {
      const span = document.createElement('span');
      if (i < this.state.slideIndex) span.classList.add('is-done');
      if (i === this.state.slideIndex) {
        span.classList.add('is-active');
        span.style.setProperty('--hs-duration', `${this.state.durationMs}ms`);
      }
      this.progress.appendChild(span);
    });
  }

  play() {
    this.stop();

    const { item } = this.getCurrent();
    if (!item) return;

    const isVideo = item.type === 'video' && item.video;

    if (!isVideo) {
      this.state.timer = setTimeout(() => this.next(), this.state.durationMs);
      return;
    }

    const video = this.viewer?.querySelector('video');
    if (!video) return;

    this.activeVideo = video;
    video.playsInline = true;

    const activeBar = this.progress?.querySelector('span.is-active');

    const syncDuration = () => {
      if (activeBar && Number.isFinite(video.duration) && video.duration > 0) {
        activeBar.style.setProperty('--hs-duration', `${Math.round(video.duration * 1000)}ms`);
      }
    };

    const tryPlay = async () => {
      try {
        video.muted = this.state.isMuted;
        await video.play();
      } catch (err) {
        this.state.isMuted = true;
        video.muted = true;

        try {
          await video.play();
        } catch (e) {}

        const soundBtn = this.viewer?.querySelector('[data-home-stories-sound]');
        if (soundBtn) {
          soundBtn.textContent = '🔇';
          soundBtn.setAttribute('aria-label', 'Activar sonido');
        }
      }
    };

    tryPlay();
    video.addEventListener('loadedmetadata', syncDuration, { once: true });
    video.addEventListener('loadedmetadata', tryPlay, { once: true });

    this.onVideoEnded = () => this.next();
    video.addEventListener('ended', this.onVideoEnded);

    const scheduleFallback = () => {
      if (Number.isFinite(video.duration) && video.duration > 0) {
        const ms = Math.round(video.duration * 1000) + 250;
        this.state.timer = setTimeout(() => this.next(), ms);
      }
    };

    if (Number.isFinite(video.duration) && video.duration > 0) {
      scheduleFallback();
    } else {
      video.addEventListener('loadedmetadata', scheduleFallback, { once: true });
    }
  }

  stop() {
    clearTimeout(this.state.timer);

    if (this.activeVideo) {
      try {
        this.activeVideo.pause();
      } catch (e) {}
    }

    if (this.activeVideo && this.onVideoEnded) {
      this.activeVideo.removeEventListener('ended', this.onVideoEnded);
    }

    this.activeVideo = null;
    this.onVideoEnded = null;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.home-stories').forEach(section => {
    new HomeStories(section);
  });
});